import pages from './site-pages.json';

export interface SitePage {
  readonly path: string;
  readonly title: string;
  readonly description: string;
  readonly indexable: boolean;
  readonly breadcrumb: string | null;
}

/// Prerender listesi, sitemap ve sayfa SEO'su bu kayıttan beslenir
/// (scripts/site/build-site.mjs aynı JSON'u okur). Yasal sayfalar
/// src/content/legal/*.md frontmatter'ından gelir.
export const SITE_PAGES: readonly SitePage[] = pages;

export function sitePage(path: string): SitePage {
  const page = SITE_PAGES.find((p) => p.path === path);
  if (!page) {
    throw new Error(`site-pages.json içinde "${path}" kaydı yok`);
  }
  return page;
}
